module.exports = __webpack_public_path__ + "img/14.b93c9f14.jpg";